import { graphql } from "gatsby"
import React from "react"

import CardPlain from "@knowit-alma/common/src/components/molecules/CardPlain/CardPlain"
import CardRows from "@knowit-alma/common/src/components/organisms/CardRows/CardRows"

const CardPlainGrid = ({ blockDataCardPlainGrid }) => {
  const { heading, cards } = blockDataCardPlainGrid || {}

  const headingMain = heading

  const cardsMapped = cards?.map((card, index) => {
    const { heading, text, link } = card
    return (
      <CardPlain
        key={index}
        headingSize={headingMain ? "h3" : "h2"}
        heading={heading}
        text={text}
        link={link}
      />
    )
  })

  return (
    <section className="base-margin-top-large base-margin-bottom-large">
      <CardRows heading={headingMain}>{cardsMapped}</CardRows>
    </section>
  )
}

export const query = graphql`
  fragment CardPlainGrid on WpBlockAcfCardPlainGrid {
    __typename
    blockDataCardPlainGrid {
      heading
      cards {
        heading
        text
        link {
          url
          title
          target
        }
      }
    }
  }
`

export default CardPlainGrid
